// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
	production: false,
	// BASE_URL_API: 'https://bsgestao.brunsker.com.br/api/', //Homologacao
	BASE_URL_API: 'https://hml-bsgestao.brunsker.com.br/api/', //Produção
	// BASE_URL_API: 'http://localhost:4444/api/',

	CHATBOT_API: 'https://hml-bs-chatbot.brunsker.com.br/api/',
	// CHATBOT_API: 'https://bs-chatbot.brunsker.com.br/api/', // prod
	ATENDIMENTO_SOCKET: 'wss://hml-bs-chatbot.brunsker.com.br/atendimento-hub',
	// ATENDIMENTO_SOCKET: 'wss://bs-chatbot.brunsker.com.br/atendimento-hub', // prod
	USUARIO_SOCKET: 'wss://hml-bs-chatbot.brunsker.com.br/usuario-hub',
	// USUARIO_SOCKET: 'wss://bs-chatbot.brunsker.com.br/usuario-hub', // prod
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
